import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftBoxResponse } from '@models/gift';
import { GiftCouponStatusKr } from '@models/gift/extension';
import dayjs from 'dayjs';
import { Fragment } from 'react';

import styles from './styles.module.scss';

interface Props {
    giftBox: GiftBoxResponse
}

function PurchaseInfo({ giftBox }:Props) {
  const {
    receiverName, giftCoupon, payment,
  } = giftBox;
  return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <Text color={colors.gray6}>받는 사람</Text>
                <Text fontWeight='bold' color={colors.gray7}>{receiverName}</Text>
                {giftCoupon && (
                    <Fragment>
                        <Text color={colors.gray6}>유효기간</Text>
                        <Text fontWeight='bold' color={colors.gray7}>
                            {dayjs(giftCoupon.startedAt).format('YYYY.MM.DD')}
                            &nbsp;~&nbsp;
                            {dayjs(giftCoupon.expiredAt).format('YYYY.MM.DD')}
                        </Text>
                        <Text color={colors.gray6}>쿠폰 상태</Text>
                        <Text fontWeight='bold' color={colors.gray7}>
                            {GiftCouponStatusKr[giftCoupon.status]}
                        </Text>
                    </Fragment>
                )}
                <Text color={colors.gray6}>결제수단</Text>
                <Text fontWeight='bold' color={colors.gray7}>
                    {payment.paymentMethod === 'CREDIT_CARD' ? '신용카드' : '선불카드'}
                </Text>
                <Text color={colors.gray6}>결제금액</Text>
                <Text fontWeight='bold' color={colors.red}>
                    {payment.amount.toLocaleString()}원
                </Text>
            </div>
        </div>
  );
}

export default PurchaseInfo;
